export default {
  language: {
    language: '语言',
    zh: '中国',
    en: '英国'
  }
};



// WEBPACK FOOTER //
// ./src/lang/zh.js